module.exports = __webpack_public_path__ + "static/media/22.bb28b268.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/22.png
// module id = 1128
// module chunks = 0